import { useLayoutEffect } from 'react';
import i18n from '../i18n.js';
import { readUserLanguage, storeUserLanguage, type InterfaceLanguage } from './languageStorage.js';

/**
 * La langue du compte sert de repli ; le choix d'interface reste personnel au
 * navigateur. Un lien `?lang=` est consommé par `useEntryParams`, qui
 * enregistre la préférence avant de retirer le paramètre par le routeur.
 */
export function useUserLanguage(
  accountId: string | null,
  accountLanguage: InterfaceLanguage,
): void {
  useLayoutEffect(() => {
    if (!accountId) return;
    void i18n.changeLanguage(readUserLanguage(accountId) ?? accountLanguage);
  }, [accountId, accountLanguage]);
}

export function changeUserLanguage(accountId: string, language: InterfaceLanguage): void {
  storeUserLanguage(accountId, language);
  void i18n.changeLanguage(language);
}
